import { Component, inject } from '@angular/core';
import { AbstractControl, FormArray, FormBuilder, ReactiveFormsModule, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { FocusDirective } from './../../../../../core/directives/focus/focus.directive';
import { Table } from '../../../models/class/table.class';
import { Attribute } from '../../../models/class/attribute.class';
import { ToCreateAttribute } from '../../../models/to-create/to-create-attribute.type';
import { DatabaseModelService } from '../../../services/database-model/database-model.service';
import { TableAlreadyExistsValidator } from '../../../validators/table-already-exists/table-already-exists.validator';
import { TrashComponent } from './../../../../../core/components/svg/trash/trash.component';

@Component({
  selector: 'dbm-table-form',
  standalone: true,
  imports: [ReactiveFormsModule, FocusDirective, TrashComponent],
  templateUrl: './table-form.component.html',
  styleUrls: ['./table-form.component.scss', './../dbm-form.style.scss'],
})
export class TableFormComponent {
  private _formBuilder: FormBuilder = inject(FormBuilder);
  private _modelService: DatabaseModelService = inject(DatabaseModelService);
  tableValidator: TableAlreadyExistsValidator = inject(TableAlreadyExistsValidator);

  tableForm = this._formBuilder.group({
    tableTitle: ['', [Validators.required], [this.tableValidator.validate.bind(this.tableValidator)], 'blur'],
    tableAttributes: this._formBuilder.array([]),
  });

  get attributes(): FormArray {
    return this.tableForm.get('tableAttributes') as FormArray;
  }

  addTableAttributes(): void {
    const attributesGroup = this._formBuilder.group({
      name: ['', [Validators.required, this.attributeExistsValidator()]],
    });
    this.attributes.push(attributesGroup);
  }

  removeTableAttribute(index: number): void {
    this.attributes.removeAt(index);
  }

  onSubmit(): void {
    const table: Table = new Table(
      this.tableForm.value.tableTitle as string,
      (this.tableForm.value.tableAttributes as ToCreateAttribute[]).map((dto: ToCreateAttribute) => Attribute.mapFromToCreateDto(dto))
    );
    this._modelService.addTable(table);
    this.tableForm.reset();
  }

  attributeExistsValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      if (!control.value) return null;
      for (const attributeControl of this.attributes.controls) {
        if (attributeControl.value.name == control.value) {
          return { attributeExists: `L'attribut ${control.value} existe déjà` };
        }
      }
      return null;
    };
  }
}
